package com.essntl.features.authentication.data.repository

import com.essntl.core.utils.repository.Repository
import com.essntl.features.authentication.data.data.CheckDto
import com.essntl.features.authentication.domain.models.CheckModel
import com.essntl.features.authentication.domain.repository.AuthRepository
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.functions.functions
import io.github.jan.supabase.auth.OtpType
import io.github.jan.supabase.auth.SignOutScope
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.auth.providers.builtin.Email
import io.github.jan.supabase.auth.providers.builtin.OTP
import io.github.jan.supabase.auth.status.SessionStatus
import io.ktor.client.call.*
import kotlinx.coroutines.flow.StateFlow
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.koin.core.annotation.Single

@Single(binds = [AuthRepository::class])
internal class AuthRepositoryImpl internal constructor(
    private val supabase: SupabaseClient,
) : Repository(), AuthRepository {
    override suspend fun signInWithOTP(essentialEmail: String): Result<Unit> =
        runCatching {
            supabase.auth.signInWith(OTP) {
                email = essentialEmail
                createUser = false
            }
        }

    override suspend fun verifyEmailOtp(
        essentialEmail: String,
        token: String,
    ): Result<Unit> =
        runCatching {
            supabase.auth.verifyEmailOtp(
                OtpType.Email.MAGIC_LINK,
                email = essentialEmail,
                token = token,
            )
        }



    override fun verifySession(): StateFlow<SessionStatus> = supabase.auth.sessionStatus

    override suspend fun signOut() {
        supabase.auth.signOut(SignOutScope.LOCAL)
    }

    override suspend fun tryRefresh() {
        supabase.auth.currentSessionOrNull()?.refreshToken?.let {
            supabase.auth.refreshSession(it)
        }
    }

    override suspend fun getCurrentUserId(): Result<String?> =
        runCatching {
            supabase.auth.currentUserOrNull()?.id
        }

    override suspend fun checkEmail(email: String): Result<CheckModel> =
        runCatching {
            supabase.functions.invoke(
                function = "auth/check",
                body = buildJsonObject {
                    put("email", email)
                },
            ).body<CheckDto>()
                .toModel()
        }

    override suspend fun register(
        email: String,
        firstName: String,
        lastName: String,
    ): Result<Unit> =
        runCatching {
            supabase.functions.invoke(
                function = "auth/signup",
                body = buildJsonObject {
                    put("email", email)
                    put("first_name", firstName)
                    put("last_name", lastName)
                },
            )
        }
}
